import type { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import type { StoreFieldsActions } from '../../common/hooks/use-store-fields/types.tsx';
import getFilteredCard from '../../rest/filtered-cards/index.tsx';
import type { SetAppDataPayload } from '../../state/actions/app/index.tsx';
import type { EpicIssueTypeState } from '../../state/reducers/config/epic/types.tsx';
import { loadPlanDataService } from '../load-plan-data/index.tsx';
import type { ServiceContext } from '../service-context/index.tsx';

interface Params {
	issueIds: number[];
	customFilterIds: string[];
	epicIssueType: EpicIssueTypeState | null;
	storeFieldsActions?: StoreFieldsActions | null;
}

interface ReturnData {
	data?: SetAppDataPayload;
	filteredCardIds: string[];
}

export function fetchFilteredCardsService(
	ctx: ServiceContext,
	{ issueIds, customFilterIds, epicIssueType, storeFieldsActions }: Params,
): Observable<ReturnData> {
	if (ctx.isCompanyManaged) {
		return loadPlanDataService({
			boardId: ctx.boardId,
			isCompanyManaged: ctx.isCompanyManaged,
			activeQuickFilters: customFilterIds,
			epicIssueType,
			storeFieldsActions,
		}).map((data) => ({
			data,
			filteredCardIds: Object.values(data.entities.card)
				.filter((card) => !card.hidden)
				.map((card) => String(card.id)),
		}));
	}

	return getFilteredCard('', ctx.boardId, issueIds, customFilterIds).map((filteredCardIds) => ({
		filteredCardIds,
	}));
}
